import { Link } from "react-router-dom";
import BasedOnLogoBig from "../../assets/img/BasedOnLogoBig.svg";

export default function LogoBig() {
	return (
		<Link to="/">
			<img src={BasedOnLogoBig} alt="BasedOn" />
		</Link>
	);
}
